// src/middleware/jsonResponse.js
var jsonResponse_default = function jsonResponse_default(opts) {
  return {
    onResponse: function onResponse(response) {
      var contentType = response.headers["content-type"] || "";
      var shouldDecode = opts && opts.force || contentType.indexOf("application/json") !== -1;

      if (!response.body || !contentType || !shouldDecode) {
        return response;
      }

      return Object.assign({}, response, {
        body: tryParse(response.body)
      });
    },
    processOptions: function processOptions(options) {
      return Object.assign({}, options, {
        headers: Object.assign({
          Accept: "application/json"
        }, options.headers)
      });
    }
  };
};

function tryParse(body) {
  try {
    return JSON.parse(body);
  } catch (err) {
    err.message = "Failed to parsed response body as JSON: ".concat(err.message);
    throw err;
  }
}

export { jsonResponse_default };